import type { Components } from "@mui/material/styles";

export const MuiTableHead: Components["MuiTableHead"] = {
  styleOverrides: {
    root: {
      fontSize: "var(--font-size-s)",
      background: "var(--color-grey)",
    },
  },
};

export const MuiTableRow: Components["MuiTableRow"] = {
  styleOverrides: {
    root: {
      "&:nth-of-type(even)": {
        backgroundColor: "var(--color-table-row)",
      },
    },
  },
};

export const MuiTableCell: Components["MuiTableCell"] = {
  styleOverrides: {
    root: {
      fontSize: "var(--font-size-s)",
    },
    head: {
      fontWeight: "bold",
      textAlign: "center",
      color: "var(--color-white)",
    },
  },
};
